import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from "date-fns";

import {
  ConfigItem,
  DealerInfoIProps,
  FastFilterItem,
  FormValues,
  OptionsIProps,
} from "./schema/types";

export const LOCALIZE_DEALERS: OptionsIProps[] = [
  { value: "dealer", label: "Дилер" },
  { value: "city", label: "Город" },
  { value: "subject", label: "Субъект" },
  { value: "FO", label: "ФО" },
  { value: "country", label: "Страна" },
];

export interface GetDefaultFilterIProps {
  dealerInfo: DealerInfoIProps;
  key?: "dealer" | "city" | "subject" | "FO" | "country";
}

export const getDefaultFilter = ({
  dealerInfo,
  key = "dealer",
}: GetDefaultFilterIProps): FormValues => {
  const start = new Date();
  const end = new Date();

  const dealerValue = key ? dealerInfo[key] : null;
  const option = dealerValue ? [dealerValue] : null;

  return {
    selectFrom: LOCALIZE_DEALERS[0],
    dealerSelect: option,
    startDate: start,
    endDate: end,
  };
};

export const getConfigFields = (
  dynamicOptions: OptionsIProps[],
): Record<string, ConfigItem> => ({
  selectFrom: {
    type: "select",
    label: "Отфильтровать",
    options: LOCALIZE_DEALERS,
    mode: undefined,
  },
  dealerSelect: {
    type: "select",
    label: "Значения",
    options: dynamicOptions,
    mode: "multiple",
  },
  dateRange: {
    type: "range",
    label: "Период",
    fields: { start: "startDate", end: "endDate" },
  },
});

export const FAST_FILTERS_CONFIG: FastFilterItem[] = [
  {
    name: "day",
    label: "текущий день",
    getRange: () => [new Date(), new Date()],
  },
  {
    name: "week",
    label: "текущая неделя",
    getRange: () => [
      startOfWeek(new Date(), { weekStartsOn: 1 }),
      endOfWeek(new Date(), { weekStartsOn: 1 }),
    ],
  },
  {
    name: "month",
    label: "текущий месяц",
    getRange: () => [startOfMonth(new Date()), endOfMonth(new Date())],
  },
];
